import { apiSlice } from '../../../store/api/apiSlice';

// Types
export interface EmailListItem {
  id: string;
  sent_at: string;
  status: string;
  coach_person_id: string;
  coach_name: string;
  coach_email: string;
  member_name?: string;
  email_subject?: string;
  skip_reason?: string;
  artifact_id?: string;
  category?: string;
}

export interface ListEmailsResponse {
  emails: EmailListItem[];
  total: number;
  page: number;
  per_page: number;
}

export interface ListEmailsParams {
  page?: number;
  per_page?: number;
  status?: string;
  coach?: string;
  member?: string;
  from_date?: string;
  to_date?: string;
  category?: string;
}

export interface GlobalStatusResponse {
  enabled: boolean;
}

export interface SetGlobalStatusParams {
  enabled: boolean;
}

export interface CategoriesResponse {
  categories: string[];
}

// API endpoints
export const emailsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    listEmails: builder.query<ListEmailsResponse, ListEmailsParams>({
      query: (params) => ({
        url: '/admin/emails',
        params,
      }),
      providesTags: ['Emails'],
    }),
    getAutoSummaryGlobalStatus: builder.query<GlobalStatusResponse, void>({
      query: () => '/admin/autosummary/global-status',
      providesTags: ['AutoSummaryGlobalStatus'],
    }),
    setAutoSummaryGlobalStatus: builder.mutation<GlobalStatusResponse, SetGlobalStatusParams>({
      query: (body) => ({
        url: '/admin/autosummary/global-status',
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['AutoSummaryGlobalStatus'],
    }),
    listEmailCategories: builder.query<CategoriesResponse, void>({
      query: () => '/admin/emails/categories',
    }),
  }),
});

export const {
  useListEmailsQuery,
  useGetAutoSummaryGlobalStatusQuery,
  useSetAutoSummaryGlobalStatusMutation,
  useListEmailCategoriesQuery,
} = emailsApi;
